import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { IconButton, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="default" />
			<Text semiBold text="primary" />
			<Text semiBold text="secondary" />
			<Text semiBold text="outline" />
			<IconButton
				design="default"
				round
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				design="primary"
				round
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				design="secondary"
				round
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				design="outline"
				round
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
		</CssColumnGrid>
	);
};